import { Loader } from './styles';
import { Icon } from '../form/input/styles';

// eslint-disable-next-line import/prefer-default-export
export const LoaderBox = ({ height = 300, isAbsolute = false }) => (
  <Loader height={height} isAbsolute={isAbsolute}>
    <Icon className="icon-loader" size={height} />
  </Loader>
);
